import React, { useContext, useState } from "react";

import Head from "next/head";
import isMobile from "is-mobile";

import { Config } from "../environment/config";
import { Env } from "@emed-labs/virtual-lab-models";
import { EnvironmentContext } from "../providers/EnvironmentProvider";
import { SiteFooter } from "./SiteFooter";
import { Theme } from "../models/NavigatorModels";
import { ThemeContext } from "../providers/ThemeProvider";
import { Header } from "./Header";

export interface SiteContainerProps {
	title?: string;
	hideFooter?: boolean;
	showMetricsDebugButton?: boolean;
	centered?: boolean;
	fullScreenCamera?: boolean;
	children: React.ReactNode;
}

export const SiteContainer: React.FC<SiteContainerProps> = ({
	title,
	hideFooter,
	showMetricsDebugButton,
	centered,
	fullScreenCamera,
	children
}) => {
	const environmentContext = useContext(EnvironmentContext) as Env.Reader;
	const { theme, isEmbedded } = useContext(ThemeContext);
	const environment = environmentContext.get(Config.ENVIRONMENT);
	const [hasError, setHasError] = useState<boolean>(false);

	const renderError = () => (
		<div className="container">
			<div className="content has-text-centered">
				<img src="/static/error.svg" />
				<h1>Oops!</h1>
				<p>We ran into a problem. Please try again by reloading this page.</p>
			</div>
		</div>
	);

	const renderContent = () =>
		centered || hasError ? (
			<div className={`site-content is-flex`}>
				<div className={`is-flex m-auto is-justify-content-center`}>{hasError ? renderError() : children}</div>
			</div>
		) : (
			<div className={`site-content`}>{hasError ? renderError() : children}</div>
		);

	return (
		<div className={["site-container", isEmbedded ? "embed" : undefined, fullScreenCamera ? "full-screen-camera-mode" : undefined].filter(Boolean).join(" ")}>
			{isMobile() && !isEmbedded && (
				<Header
					tags={[]}
					className="-mb-8"
					theme={theme === Theme.SheMed ? Theme.SheMed : theme === Theme.HeMed ? Theme.HeMed : "default"}
				/>
			)}
			<Head>
				<title>{title ? title + " - eMed" : "eMed"}</title>
			</Head>
			{renderContent()}
			{!isMobile() && !isEmbedded && !hideFooter && (
				<SiteFooter
					showMetricsDebug={showMetricsDebugButton}
					environmentTag={environment === "production" ? null : environment}
					white={!(theme === Theme.Dark)}
					centerContent
				/>
			)}
		</div>
	);
};
